import * as React from "react";
const SvgHandUpFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.5 2.25c.69 0 1.25.56 1.25 1.25v8.75h.5V7.5a1.25 1.25 0 0 1 2.5 0v4.75h.5V8.5a1.25 1.25 0 1 1 2.5 0v3.75h.5V9.5a1.25 1.25 0 1 1 2.5 0v6.426a5.75 5.75 0 0 1-11.5 0V3.5c0-.69.56-1.25 1.25-1.25" }));
export default SvgHandUpFill;
